import ClientAllocationForm from './ClientAllocationForm';

export default ClientAllocationForm;
